<template>
  <div class="d-flex justify-center actions-bar">
    <NewMicrositeDialog v-if="isOpen" @close="closeDialog" :isOpen="isOpen" />
    <SecondaryButton
      @click.native="openDialog"
      permission="create"
      color="primary"
    >
      <div class="d-flex align-center justify-center">
        <v-icon>mdi-trackpad</v-icon>
        <v-icon small>mdi-plus</v-icon>
      </div>
      New Microsite
    </SecondaryButton>
  </div>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import NewMicrositeDialog from "@/views/settings/components/microsites/components/dialogs/MicrositeDialog";

export default {
  components: {
    NewMicrositeDialog,
    SecondaryButton
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
<style lang="scss"></style>
